import Act from './Act';
import Model from "./Model";
import Practitioner from './Practitioner';
import { ClassTransformOptions, plainToClass, Type } from "class-transformer";

class ActCategory extends Model {

    id: number;
    name: string;
    parent_id: number;
    practitioner_id: number;
    establishment_id: number;
    @Type(() => Date)
    created_at: Date;
    @Type(() => Date)
    updated_at: Date;


    /*
    |--------------------------------------------------------------------------
    | Reflection
    |--------------------------------------------------------------------------
    */

    /**
     * Gets class name
     * survives minification/uglification
     *
     * @return {string}
     */
    getClassName(): string {
        return 'ActCategory';
    }

    /*
    |--------------------------------------------------------------------------
    | Relationships
    |--------------------------------------------------------------------------
    */

    @Type(() => Practitioner)
    practitioner: Practitioner;

    @Type(() => ActCategory)
    parent: ActCategory;

    @Type(() => ActCategory)
    children: ActCategory[];

    @Type(() => Act)
    acts: Act[];

    /*
    |--------------------------------------------------------------------------
    | Methods
    |--------------------------------------------------------------------------
    */

    /**
     * Check if category has parent
     *
     * @return {boolean}
     */
    hasParent(): boolean {
        return this.isChild();
    }

    /**
     * Check if category is parent
     *
     * @return {boolean}
     */
    isParent(): boolean {
        return !this.isChild();
    }

    /**
     * Check if category is child
     *
     * @return {boolean}
     */
    isChild(): boolean {
        return !!this.parent_id;
    }

    /**
     * Converts plain (literal) object to class (constructor) object. Also works with arrays.
     */
    static new(plain: [], options?: ClassTransformOptions): ActCategory[];
    static new(plain: {}, options?: ClassTransformOptions): ActCategory;
    static new(plain: {} | [], options?: ClassTransformOptions): ActCategory | ActCategory[] {
        return plainToClass(ActCategory, plain as any, options);
    }
}

export default ActCategory;
